import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	padding: 3em 0 2em 0;

	.history {
		display: flex;
		flex-flow: column wrap;
		width: 100%;
		gap: 2em;

		.history-box {
			.history-header {
				font-size: 1em;
				font-weight: 600;
				margin: 0 0 1em 0;
				overflow: hidden;
			}

			.history-content {
				font-size: 1em;
				line-height: 1.4em;
				overflow: hidden;
			}
		}
	}
`;
